<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Article Details</div>
                </div>
                <div class="col-md-2 offset-md-4 text-right center">
                    <button type="submit" class="btn btn-warning btn-fill" @click="editArticle">Edit Article</button>
                </div>
            </div>
            <div class="table-responsive" v-if="article">
                <table class="table table-bordered table-light">
                    <tr>
                        <th>Id</th>
                        <td>{{article.toneArticleId}}</td>
                    </tr>
                  <tr>
                    <th>Published Date</th>
                    <td>{{article.datePublishFmt}}</td>
                  </tr>
                  <tr>
                    <th>Title</th>
                    <td>{{article.articleHead}}</td>
                  </tr>
                  <tr>
                    <th>Expert Name</th>
                    <td>{{article.authorName}}</td>
                  </tr>
                  <tr>
                  <tr>
                    <th>Expert Name (Optional URL)</th>
                    <td>{{article.authorUrl}}</td>
                  </tr>
                  <tr>
                    <th>Image</th>
                    <td ><img class="table-thumbnail" :src="article.imageUrl" :title="article.imageUrl" />
                      <br>
                      (URL: <a :href="article.imageUrl" target="_blank"> {{article.imageUrl}} </a>)
                    </td>
                  </tr>
                  <tr>
                    <th>Paragraph 1</th>
                    <td><p v-html="article.paragraph1"></p></td>
                  </tr>
                  <tr>
                    <th>Paragraph 2</th>
                    <td><p v-html="article.paragraph2"></p></td>
                  </tr>
                  <tr>
                    <th>Paragraph 3</th>
                    <td><p v-html="article.paragraph3"></p></td>
                  </tr>
                  <tr>
                    <th>Paragraph 4</th>
                    <td><p v-html="article.paragraph4"></p></td>
                  </tr>
                  <tr>
                    <th>Paragraph 5</th>
                    <td><p v-html="article.paragraph5"></p></td>
                  </tr>
                  <tr>
                    <th>Paragraph 6</th>
                    <td><p v-html="article.paragraph6"></p></td>
                  </tr>
                  <tr>
                    <th>Paragraph 7</th>
                    <td><p v-html="article.paragraph7"></p></td>
                  </tr>
                  <tr>
                    <th>Paragraph 8</th>
                    <td><p v-html="article.paragraph8"></p></td>
                  </tr>
                  <tr>
                    <th>Paragraph 9</th>
                    <td><p v-html="article.paragraph9"></p></td>
                  </tr>
                  <tr>
                    <th>Paragraph 10</th>
                    <td><p v-html="article.paragraph10"></p></td>
                  </tr>
                    <tr>
                        <th>Status</th>
                        <td v-if="article.active">Active</td>
                        <td v-else>Inactive</td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
    import LTable from 'src/components/UIComponents/Table.vue'
    import { mapGetters } from 'vuex'
    export default {
        name: 'ViewArticle',
        components: {
            LTable,
        },
        created (){
        this.$store.dispatch('GETSELECTEDARTICLE', this.$route.params.id).then(() =>{
            console.log('selected', this.selectedGreeting)
            this.article = this.selectedArticle;
        })
    },
    data () {
        return {
          article: {}
        }
    },
    methods: {
        editArticle(){
            this.$router.push({ name: 'EditArticle', params: { id: this.article.toneArticleId}})
        },
    },
    computed: {...mapGetters([
        'selectedArticle'])
    }
    }
</script>

<style>
    th{
        width: 180px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Articles/ArticleDetails.vue